import store from '../../store';
import axios from 'axios';


export default {
    /**
     * @async
     * @param {*}       context    - unused (?)
     * @param {string}  bucket     - name of bucket
     * @param {string}  object     - name of object
     * @param {string}  method     - s3 operation (getObject, putObject, etc)
     * @param {boolean} [videoUrl] - denotes that this is a video upload, but has no real effect (?)
     * @param {string}  [type]     - if one of ['feedback', 'video', 'intro'], returns CloudFront url instead of S3 url
     * @returns {object} res
     * @returns {string} res.data - the presigned url
     */
    getPresignedUrl(context, bucket, object, method, videoUrl, type) {
        var url = window.apiUrl;
        if (videoUrl === true) {
            url += '/aws-presigned-video-url/';
        } else {
            url += '/aws-presigned-url/';
        }
        url = url + method + '/' + bucket + '/' + object;

        if (type) {
            url += '?type=' + type
        }
        var options = {
            url: url,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;
        });

    },
    signature(file, filename, bucket, contentDisposition) {
        var url = window.apiUrl + '/aws-signature?bucket=' + bucket + '&filename=' + filename + '&filetype=' + encodeURIComponent(file.type);
        if (contentDisposition) {
            url += '&content-disposition=' + contentDisposition;
        }

        var options = {
            url: url,
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },

    async multipartUpload(file, filename, bucket) {
        return new Promise(async (resolve, reject) => {
            const startedAt = new Date();

            const FILE_CHUNK_SIZE = 1 * 1024 * 1024 * 1024;

            let options = {
                method: 'POST',
                url: window.apiUrl + '/aws-multipart-upload/',
                data: {
                    key: filename,
                    bucket: bucket,
                    size: file.size
                },
                headers: { 'Authorization': 'Bearer ' + localStorage.token },
            }

            const multipartUpload = await axios.request(options);
            const urls = multipartUpload.data.presignedUrls;

            const totalSize = file.size;
            let progress = 0;

            const etags = [];

            for (const [index, url] of urls.entries()) {

                let chunkProgress = 0;

                const start = index * FILE_CHUNK_SIZE;
                const end = (index + 1) * FILE_CHUNK_SIZE;
                let blob;
                if (index < urls.length) {
                    blob = file.slice(start, end);
                } else {
                    blob = file.slice(start);
                }
                const options = {
                    headers: {
                        'Content-Type': file.type
                    },
                    onUploadProgress: function(e) {

                        progress += e.loaded - chunkProgress;
                        chunkProgress = e.loaded;
                        const percentComplete = progress / totalSize;

                        var secondsElapsed = (new Date().getTime() - startedAt.getTime()) / 1000;
                        var bytesPerSecond = secondsElapsed ? progress / secondsElapsed : 0;
                        var kilobytesPerSecond = bytesPerSecond / 1000;

                        var data = {
                            type: 'uploadProgress',
                            data: {
                                progress: (percentComplete * 100).toFixed(2),
                                loaded: progress,
                                total: totalSize,
                                speed: kilobytesPerSecond
                            }
                        };

                        store.dispatch('populate', data);

                    }
                };

                const part = await axios.put(url, blob, options);
                etags.push(part.headers.etag);

            }

            const parts = etags.map((etag, index) => {
                return {
                    PartNumber: index + 1,
                    ETag: etag
                }
            });


            options = {
                method: 'POST',
                url: window.apiUrl + '/complete-aws-multipart-upload/',
                data: {
                    bucket: bucket,
                    key: filename,
                    uploadId: multipartUpload.data.uploadId,
                    parts: parts
                },
                headers: { 'Authorization': 'Bearer ' + localStorage.token },
            }

            const finished = await axios.request(options);

            store.dispatch('populate', {
                type: 'uploadProgress',
                data: null
            });

            let response;

            if (finished.data) {
                response = {
                    success: true,
                    data: finished.data.Location,
                    url: finished.data.Location
                }
            } else {
                response = {
                    success: true,
                    data: finished.Location,
                    url: finished.Location
                }
            }
            resolve(response)
        })

    },

    upload(file, filename, signature, bucket, presignedUrl, contentDisposition) {
        
        const cutoff = 3 * 1024 * 1024 * 1024;

        if (file.size > cutoff) {
            return new Promise(async (resolve, reject) => {
                const upload = await this.multipartUpload(file, filename, bucket);
                resolve(upload);
            });
        }


        var response = {
            success: true
        };

        return new Promise(function(resolve, reject) {
            var started_at = new Date();

            if (typeof signature === 'string') signature = JSON.parse(signature);
            if (signature.data) signature = signature.data;

            const formData = new FormData();

            formData.append('key', filename);
            formData.append('acl', signature.params.acl);
            formData.append('success_action_status', '201');
            formData.append('policy', signature.params.policy);
            formData.append('Content-Type', file.type);
            if (contentDisposition) {
                formData.append('Content-Disposition', contentDisposition);
            }
            formData.append('x-amz-credential', signature.params['x-amz-credential']);
            formData.append('x-amz-algorithm', signature.params['x-amz-algorithm']);
            formData.append('x-amz-date', signature.params['x-amz-date']);
            formData.append('x-amz-signature', signature.params['x-amz-signature']);
            formData.append('file', file);


            const xhr = new XMLHttpRequest();

            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percentComplete = e.loaded / e.total;

                    var seconds_elapsed = (new Date().getTime() - started_at.getTime()) / 1000;
                    var bytes_per_second = seconds_elapsed ? e.loaded / seconds_elapsed : 0;
                    var kbytes_per_second = bytes_per_second / 1000;

                    var data = {
                        type: 'uploadProgress',
                        data: {
                            progress: (percentComplete * 100).toFixed(2),
                            loaded: e.loaded,
                            total: e.total,
                            speed: kbytes_per_second
                        }
                    };

                    store.dispatch('populate', data);
                }
            };

            xhr.onload = () => {

                if (xhr.status != 201) {
                    alert('Upload error, code ' + xhr.status)
                    console.log(`request error,code ${xhr.status}`);
                    return;
                }
                try {
                    var parser = new DOMParser();
                    var xmlDoc = parser.parseFromString(xhr.responseText, "text/xml");
                    const url = xmlDoc.getElementsByTagName("Location")[0].childNodes[0].nodeValue;

                    response.url = url;


                } catch (err) {
                    response.success = false;
                    response.message = err.toString();
                }

                var data = {
                    type: 'uploadProgress',
                    data: null
                };

                store.dispatch('populate', data);
                resolve(response);
            };
            if (presignedUrl) {
                if (presignedUrl.includes('s3-accelerate.amazonaws')) {
                    console.log("FASTER FAST FAST")
                    xhr.open('POST', 'https://' + bucket + '.s3-accelerate.amazonaws.com')
                } else {
                    xhr.open('POST', 'https://s3-us-west-2.amazonaws.com/' + bucket)
                }
            } else {
                xhr.open('POST', 'https://s3-us-west-2.amazonaws.com/' + bucket)
            }

            xhr.send(formData);

        });
    }
};



// WEBPACK FOOTER //
// ./src/services/aws/index.js